module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Consulta de bancas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('exam-filters', {
    attrs: {
      "semester-required": true
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  })], 1), _vm._v(" "), (_vm.activeMessages.length > 0) ? _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.activeMessages), function(message, idx) {
    return _c('v-alert', {
      key: 'message_' + idx,
      attrs: {
        "color": message.type,
        "value": "true",
        "dismissible": ""
      },
      model: {
        value: (message.show),
        callback: function($$v) {
          _vm.$set(message, "show", $$v)
        },
        expression: "message.show"
      }
    }, [_vm._v("\n                " + _vm._s(message.text) + "\n            ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "no-data-text": _vm.noData,
      "no-results-text": _vm.noResult,
      "rows-per-page-text": _vm.rowsPerPageT
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item) ? _c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', {
          staticClass: "no-padding"
        }, [_c('ul', {
          staticClass: "no-padding"
        }, _vm._l((props.item.studentName), function(studentName, id) {
          return _c('ol', {
            key: id,
            staticClass: "no-padding studentName"
          }, [_vm._v("\n                            " + _vm._s(studentName) + "\n                        ")])
        }), 0)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(props.item.date, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.place))]), _vm._v(" "), _c('td', [_c('v-chip', {
          class: [_vm.getExamStatusClass(props.item), 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formataNota(props.item.finalScore)))]), _vm._v(" "), _c('td', [(props.item.situation != 'Finalizada') ? _c('router-link', {
          attrs: {
            "to": {
              name: 'examPlan',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "info",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Modificar planejamento da banca"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("schedule")])], 1)], 1) : _vm._e(), _vm._v(" "), (!props.item.notificationDate) ? _c('v-btn', {
          attrs: {
            "color": "deep-orange lighten-2",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Notificar participantes"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.notifyAttendees(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("mail_outline")])], 1) : _c('v-btn', {
          attrs: {
            "color": "success",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": 'Os participantes foram notificados em ' + _vm.formatDate(props.item.notificationDate)
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.notifyAttendees(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "cyan darken-1",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver fichas de avaliação"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamEvaluation(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("gavel")])], 1), _vm._v(" "), (props.item.situation != 'Finalizada') ? _c('router-link', {
          attrs: {
            "to": {
              name: 'examDetail',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "success",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Encerrar banca"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("school")])], 1)], 1) : _vm._e(), _vm._v(" "), (props.item.situation != 'Finalizada') ? _c('router-link', {
          attrs: {
            "to": {
              name: 'examDetail',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "info",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver banca"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("description")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "orange",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver lista de presença e certificações"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamAttendance(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("playlist_add_check")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "grey darken-2",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Emitir documentos"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamDocuments(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("folder")])], 1), _vm._v(" "), (props.item.situation != 'Finalizada') ? _c('v-btn', {
          attrs: {
            "color": "error",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Cancelar banca"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.dialogCancelBanca(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("clear")])], 1) : _vm._e()], 1)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Acima estão listadas as bancas que você participa ou coordena.")])]), _vm._v(" "), _c('fullscreen-spinner'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.evaluationDialog),
      callback: function($$v) {
        _vm.evaluationDialog = $$v
      },
      expression: "evaluationDialog"
    }
  }, [_c('exam-evaluations', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.evaluationDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.attendanceDialog),
      callback: function($$v) {
        _vm.attendanceDialog = $$v
      },
      expression: "attendanceDialog"
    }
  }, [_c('exam-attendance', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.attendanceDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.documentsDialog),
      callback: function($$v) {
        _vm.documentsDialog = $$v
      },
      expression: "documentsDialog"
    }
  }, [_c('exam-documents', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.documentsDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.showDialogBanca),
      callback: function($$v) {
        _vm.showDialogBanca = $$v
      },
      expression: "showDialogBanca"
    }
  }, [_c('exam-documents', [_c('template', {
    slot: "actions"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "offset-xs2": "",
      "offset-sm2": "",
      "offset-md2": "",
      "xs10": "",
      "sm10": "",
      "md10": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Cancelar Banca")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "large": "",
      "href": "https://codepen.io/johnjleider/pen/wyYVVj",
      "target": "_blank"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-codepen")])], 1), _vm._v(" "), _c('span', [_vm._v("Codepen")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "record_voice_over",
      "label": "Motivo do cancelamento",
      "type": "text"
    },
    model: {
      value: (_vm.obs_of_situation),
      callback: function($$v) {
        _vm.obs_of_situation = $$v
      },
      expression: "obs_of_situation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelarBanca(_vm.dialogItem)
      }
    }
  }, [_vm._v("Confirmar Cancelamento")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    style: (_vm.styleButtonDialog),
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.showDialogBanca = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-590b94fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamList.vue
// module id = 247
// module chunks = 0